import { CSSProperties } from "styled-components";
import { Button } from "./styled";
import { Spin } from "antd";

//PROPS
interface Props {
    value?: string;
    icon?: React.ReactNode;
    children?: React.ReactNode;
    onClick: Function;
    onMouseOver?: Function;
    onMouseLeave?: Function;
    type?: 'primary' | 'secondary' | 'tertiary'
    danger?: boolean;
    disabled?: boolean;
    style?: CSSProperties;
    refProp?: any,
    loading?: boolean,
    hidden?: boolean,
    title?: string;
    isCircle?: boolean;
    notReady?: boolean;
    onClickNotReady?: Function;
}

const ButtonCustom: React.FC<Props> = ({ value, icon, onClick, type, danger, children, disabled, style, refProp, loading, hidden, title, 
    isCircle, onMouseOver, onMouseLeave, notReady, onClickNotReady
 }) => {
    
    if (hidden) {
        return null
    };

    return (
        <Button 
            className="ttivos-button"
            data-type={type??'primary'}
            data-danger={danger}
            data-notready={notReady}
            onClick={notReady ? ()=>{onClickNotReady?.()} : ()=>{onClick?.()}}
            value={value}
            disabled={disabled || loading}
            style={{...style, borderRadius: isCircle ? '50%' : undefined, minWidth: isCircle ? 40 : undefined, minHeight: isCircle ? 40 : undefined}}
            type="button"
            ref={refProp}
            title={title}
            onMouseOver={()=>onMouseOver?.()}
            onMouseLeave={()=>onMouseLeave?.()}
        >
            
            {loading ? <Spin size="small" /> : <>{icon}</>}
            {children}
        </Button>
    )
};

export default ButtonCustom;